import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-2 lg:px-8 pt-3 pb-5" }
const _hoisted_2 = { class: "w-full table-fixed text-sm relative border border-next-light-gray" }
const _hoisted_3 = ["span"]
const _hoisted_4 = {
  class: "sticky bg-next-light-gray border border-next-light-gray",
  style: {"top":"calc(var(--top-navigation-height))"}
}
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "flex flex-col md:flex-row pt-4 items-center md:mb-4 gap-3" }
const _hoisted_7 = { class: "flex justify-self-end" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["colspan"]
const _hoisted_11 = { class: "border border-next-gray-md-darker" }
const _hoisted_12 = { class: "border border-next-gray-md-darker font-bold" }
const _hoisted_13 = { class: "border border-next-gray-md-darker font-bold" }
const _hoisted_14 = { class: "border border-next-gray-md-darker font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonthSwitcher = _resolveComponent("MonthSwitcher")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("colgroup", null, [
        _cache[2] || (_cache[2] = _createElementVNode("col", { class: "w-[200px]" }, null, -1)),
        _createElementVNode("col", { span: _ctx.monthDayIterator }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("thead", _hoisted_4, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            colspan: _ctx.monthDayIterator + 2,
            class: "border border-next-light-gray"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-bold text-lg md:text-3xl" }, "Controllo timesheet", -1)),
              _createVNode(_component_MonthSwitcher, {
                date: _ctx.date,
                "onUpdate:date": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                class: "w-full max-w-[14rem]"
              }, null, 8, ["date"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                    _ctx.onSearch
                  ],
                  "label-visible": false,
                  placeholder: "Cerca",
                  type: "text"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ])
          ], 8, _hoisted_5)
        ]),
        _createElementVNode("tr", null, [
          _cache[4] || (_cache[4] = _createElementVNode("th", { class: "bg-white border border-next-gray-md-darker sticky" }, "Utente", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthDayIterator, (d) => {
            return (_openBlock(), _createElementBlock("th", {
              class: _normalizeClass(["bg-white border border-next-gray-md-darker sticky", _ctx.getDayClass(d)])
            }, _toDisplayString(d), 3))
          }), 256)),
          _cache[5] || (_cache[5] = _createElementVNode("th", { class: "bg-white border border-next-gray-md-darker sticky" }, null, -1))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_8, [
        (!Object.keys(_ctx.Matrix).length)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
              _createElementVNode("td", {
                colspan: _ctx.monthDayIterator + 2,
                class: "border border-next-gray-md-darker text-center"
              }, "Non sono presenti timesheet registrati ", 8, _hoisted_10)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Matrix, (r, i) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(r['name']), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthDayIterator, (d) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: _normalizeClass(["border border-next-gray-md-darker", `${_ctx.getHourCompletion(r['timesheet'][d + 1])} ${_ctx.getDayClass(d)}`])
                    }, _toDisplayString(_ctx.timeToFormat(r['timesheet'][d + 1]?.totale_minuti)), 3))
                  }), 256)),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.timeToFormat(r['timesheet'].reduce((acc, val) => acc + parseInt(val?.totale_minuti || 0), 0))), 1)
                ]))
              }), 256)),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "border border-next-gray-md-darker" }, " ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthDayIterator, (d) => {
                  return (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(_ctx.timeToFormat(_ctx.totalMinutesPerDay(d + 1))), 1))
                }), 256)),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.timeToFormat([...Array(_ctx.monthDayIterator)].reduce((acc, d, idx) => acc + _ctx.totalMinutesPerDay(idx), 0))), 1)
              ])
            ], 64))
      ])
    ])
  ]))
}